import React from 'react';

import { Accordion } from 'apps/promo/components/common/accordion/Accordion';
import { PromoText } from 'apps/promo/components/common/promo-text/PromoText';

import styles from './TransferAccordion.module.css';
import type { TransferMethodsMap, TransferMethodsProps } from './transferMethods.types';
import { buildTransferMethodsMap } from './transferMethods.utils';

export const TransferAccordion = ({ transferMethods = [] }: TransferMethodsProps) => {
    const methodsMap: TransferMethodsMap = buildTransferMethodsMap(transferMethods);
    const allRowTitles = Object.keys(methodsMap);

    const items = allRowTitles.map((rowTitle) => ({
        id: rowTitle,
        header: (
            <PromoText color={'baseColor'} tag={'span'}>
                {rowTitle}
            </PromoText>
        ),
        content: (
            <div className={styles.contentList}>
                {transferMethods.map((method, methodIndex) => {
                    const rowText = methodsMap[rowTitle][methodIndex];

                    if (!rowText) return null;

                    return (
                        <div key={method.id} className={styles.contentItem}>
                            <div>
                                {method.method_icon && (
                                    <img className={styles.headerIcon} src={method.method_icon.url} alt={method.method_name} title={method.method_name} />
                                )}
                            </div>
                            <div>
                                <div className={styles.methodName}>
                                    <PromoText tag={'div'} variant={'h4'} gradientColor={'aubergine04'}>
                                        {method.method_name}
                                    </PromoText>
                                </div>
                                <PromoText tag={'div'} color={'gray80'}>
                                    {rowText}
                                </PromoText>
                            </div>
                        </div>
                    );
                })}
            </div>
        ),
    }));

    return <Accordion items={items} isFirstOpened />;
};
